(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["faq"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const faqSections = document.querySelectorAll('.faq-section');

  faqSections.forEach(faqSection => {
    const questions = faqSection.querySelectorAll('.faq-question');

    questions.forEach(question => {
      question.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const answer = document.getElementById(this.getAttribute('aria-controls'));

        questions.forEach(otherQuestion => {
          if (otherQuestion !== this) {
            otherQuestion.setAttribute('aria-expanded', 'false');
            const otherAnswer = document.getElementById(otherQuestion.getAttribute('aria-controls'));
            if (otherAnswer) {
              otherAnswer.style.maxHeight = '0';
            }
          }
        });

        if (isExpanded) {
          this.setAttribute('aria-expanded', 'false');
          if (answer) {
            answer.style.maxHeight = '0';
          }
        } else {
          this.setAttribute('aria-expanded', 'true');
          if (answer) {
            answer.style.maxHeight = answer.scrollHeight + 'px';
          }
        }
      });
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
